/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useDebounce from 'modules/common/hooks/useDebounce';
import Select from 'react-select';
import { reactSelectFilterStyle } from 'modules/common/components/Select';
import * as actions from '../action';
import * as c from '../constant'; 
import FeeContent from './FeeContent';
import FeeModal from '../components/FeeModal';

const INIT_FILTER = {
  q: '',
  sort_by: 'desc',
  module: '',
  fee_type: ''
};

const FilterByModuleType = ({ value, ...rest }) => {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <Select
        placeholder="Transaction Type"
        value={
          c.MODULE_TYPE.find(
            (item) => `${value}` === `${_.get(item, 'value')}`
          ) || ''
        }
        styles={reactSelectFilterStyle}
        options={c.MODULE_TYPE}
        {...rest}
      />
    </div>
  );
};

const FilterByFeeType = ({ value, ...rest }) => {
  return (
    <div className="d-flex align-items-center justify-content-center mr-2">
      <Select
        placeholder="Fee Type"
        value={
          c.FEE_TYPE_FILTER.find(
            (item) => `${value}` === `${_.get(item, 'value')}`
          ) || ''
        }
        styles={reactSelectFilterStyle}
        options={c.FEE_TYPE_FILTER}
        {...rest}
      />
    </div>
  );
};

FilterByModuleType.propTypes = {
  value: PropTypes.string.isRequired,
};

FilterByFeeType.propTypes = {
  value: PropTypes.string.isRequired,
};

function FeesContainer({
  getFeeList,
  feeList,
  match,
  history,
  isLoading,
  feeListPager,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.value,
    });
  };

  const debouncedSearchTerm = useDebounce(filter, 500);

  useEffect(() => {
    if (debouncedSearchTerm) {
      getFeeList(debouncedSearchTerm);
    } else {
      setFilter([]);
    }
  }, [debouncedSearchTerm]);

  const handleModal = (feeInfo, feeId) => {
    setModal({
      isOpen: true,
      content: (
        <FeeModal
          feeInfo={feeInfo}
          feeId={feeId}
          filter={debouncedSearchTerm}
        />
      ),
      title: `${feeInfo ? 'Edit' : 'Add'} Fee`,
      modalSize: 'modal-md',
    });
  };

  const handleOnChangeSelect = (key) => (e) => {
    setFilter((prev) => ({
      ...prev,
      [key]: e.value,
    }));
  };

  const handleOnCheck = e => {
    setFilter((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked ? 1 : 0,
    }));
  };

  return (
    <Route
      path={`${match.path}/:feeId?`}
      render={({ match: { params } }) => (
        <GenericListPair
          moduleName="Fees"
          getData={getFeeList}
          setParams={filter}
          setKeyword={handleOnChange}
          keyword={_.get(filter, 'q') || ''}
          keywordPlaceholder="Search..."
          pathName={`${match.path}/:feeId?`}
          listName="fees"
          label="Fees"
          renderItem={(item) => (
            <div className="p-3">{_.get(item, 'attributes.name')}</div>
          )}
          isLoading={isLoading}
          selected={params.feeId}
          data={feeList}
          dataPager={feeListPager}
          handleSelectRow={(data) => {
            history.push(`${match.url}/${_.get(data, 'id')}`);
          }}
          customFilter={(
            <div className="d-flex align-items-center justify-content-end my-3">
              <FilterByFeeType
                value={_.get(filter, 'fee_type')}
                onChange={handleOnChangeSelect('fee_type')}
              />
              <FilterByModuleType
                value={_.get(filter, 'module')}
                onChange={handleOnChangeSelect('module')}
              />
            </div>
          )}
          renderContent={() => (
            <React.Fragment>
              <Switch>
                <Route
                  path={`${match.path}/:feeId?`}
                  render={() => <FeeContent handleModal={handleModal} />}
                />
              </Switch>
              <Route
                path={`${match.path}/:feeId?`}
                render={() =>
                  !params.feeId && feeList.length > 0 ? (
                    <Redirect to={`${match.url}/${_.get(feeList, '0.id')}`} />
                  ) : null
                }
              />
            </React.Fragment>
          )}
        />
      )}
    />
  );
}

FeesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getFeeList: PropTypes.instanceOf(Function).isRequired,
  feeList: PropTypes.instanceOf(Array).isRequired,
  feeListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  feeList: _.get(api, `${c.GET_FEE_LIST}.list`) || [],
  feeListPager: _.get(api, `${c.GET_FEE_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_FEE_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FeesContainer);
